import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { graphql } from '../gql';
import { GetSubjectivitiesQueryVariables } from '../gql/graphql';
import { getPaginatedNodes } from './utils';
import { sortByOrder } from '@converge/utils';

export enum UnderwritingSubjectivitiesType {
  PH_ONE = 'PH_ONE',
  PH_TWO = 'PH_TWO',
  ALL = 'ALL',
}

export const GET_SUBJECTIVITIES = graphql(`
  query getSubjectivities(
    $uuid: String
    $name: String
    $type: SubjectivityType
    $pagination: PaginationRequest
  ) {
    subjectivities(
      filters: { subjectivityUuid: $uuid, name: $name, type: $type }
      pagination: $pagination
      sort: { key: "order", order: "ASC" }
    ) {
      edges {
        cursor
        node {
          order
          uuid
          type
          name
          primary
          excess
          description
          afterPolicy
          priorToPolicy
          priorToBind
          quote {
            uuid
            included
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
    }
  }
`);

export function useGetSubjectivitiesQuery({
  ...variables
}: GetSubjectivitiesQueryVariables) {
  const { loading, error, data } = useQuery(GET_SUBJECTIVITIES, {
    variables: {
      ...variables,
    },
  });
  const subjectivities = useMemo(
    () => getPaginatedNodes(data?.subjectivities).sort(sortByOrder),
    [data]
  );
  return {
    error,
    loading,
    data: data?.subjectivities,
    subjectivities,
  };
}
